module.exports = require("core-js/library/fn/number/is-nan");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/number/is-nan.js
// module id = 159
// module chunks = 35783957827783 52252321336229